import { BrowserRouter as Router } from 'react-router-dom'
import { AuthWrapper } from '../auth/AuthWrapper';
import { SnackbarProvider } from 'notistack';

function App() {
  return (
    <div className="App">
      <SnackbarProvider maxSnack={3}>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthWrapper />
        </Router>
      </SnackbarProvider>
    </div>
  );
}
export default App;
